import React from 'react'
import PropTypes from 'prop-types'
import ModalTab from './ModalTab'
import { sendWishListToDataLayer } from '../util/gtm'
import NewListInput from '../shoppinglists/Components/NewListInput'
import ProductItem from '../shoppinglists/Components/ProductItem'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import axios from 'axios';
import { translateResourceString } from '../util/translationUtility';
import { makeAxiosCatalystPostData, defaultAxiosCatalystPostConfig } from "../util/axiosUtility";

const AddToModal = ({
    Lists = [],
    UpdateLists,
    Name,
    Code,
    SKU,
    ImageUrl,
    ModalIsOpen,
    IsLoading,
    ToggleModal,
    AddItemEndpoint,
    CreateListEndpoint,
    SetLinkClass,
    SetSrText,
    SetLinkText,
    ProductVariation
}) => {

    const spinnerClass = 'fa fa-circle-notch fa-spin';
    const successClass = 'fas fa-bookmark';
    const errorClass = 'fa fa-times-circle error';
    const addToListText = translateResourceString('/Wishlist/AddToList');
    const addedToListText = translateResourceString('/Wishlist/AddedToList');

    const addProduct = (targetListName) => {

        let element = document.getElementsByClassName('qty-option-'+ Code);
        if (!element.length) element = document.getElementsByClassName('qty-option')
        
        let quantity = element.length ? element[0].value : 1
        quantity = Number.isInteger(+quantity) ? quantity : 1

        SetLinkClass(spinnerClass, Code)

        axios.post(AddItemEndpoint, makeAxiosCatalystPostData({
            listName: targetListName,
            codes: { [Code]: quantity }
        }), defaultAxiosCatalystPostConfig)
            .then(function (response) {
                switch (response.data) {
                    case 'OK':
                    case 200:
                        sendWishListToDataLayer(ProductVariation.GoogleTagManagerProductFieldObject, quantity);
                        ToggleModal(false)
                        SetLinkClass(successClass)
                        SetSrText(addedToListText)
                        SetLinkText(addedToListText)
                        break
                    case 'BadRequest':
                    case 400:
                        SetLinkClass(errorClass)
                        SetLinkText(addToListText)
                        alert(translateResourceString('/Wishlist/InvalidRequest'))
                        break
                    case 'InternalServerError':
                    case 500:
                        SetLinkClass(errorClass)
                        SetLinkText(addToListText)
                        alert(translateResourceString('/Wishlist/SomethingWentWrong'))
                        break
                }
            })
            .catch(function (error) {
                SetLinkClass(errorClass)
                SetLinkText(addToListText)
                console.log(error)
            });
    }

    return (
        <Modal
            isOpen={ModalIsOpen}
            toggle={() => ToggleModal(false)}
            centered={true}
            className="modal-lg"
            contentClassName="list-modal form-gray p-0"
            role="document">
            <ModalHeader toggle={() => ToggleModal(false)} wrapTag="div" tag="h4">{translateResourceString('/Wishlist/SelectAList')}</ModalHeader>
            <ModalBody className="list-sidebar">
                {IsLoading &&
                    <div className="list-modal-loading">
                        <i className="fa fa-spinner fa-spin fa-fw" aria-hidden="true" />
                    </div>
                }
                <div className="container-fluid">
                    <div className="row">

                        <div className="col-lg-4 d-none d-lg-block list-modal-product">
                            <ProductItem
                                Name={Name}
                                SKU={SKU}
                                ImageUrl={ImageUrl} />
                        </div>

                        <div className="col-lg-8 p-0 d-flex flex-column">
                            <ul className="p-0 list-modal-lists">
                                {
                                    Lists.map((list, i) =>
                                        <ModalTab key={i} {...list} AddProduct={addProduct} />
                                    )
                                }
                            </ul>
                            <div className="p-3 mt-2">
                                <h5>{translateResourceString('/Wishlist/CreateANewList')}</h5>
                                <NewListInput
                                    Lists={Lists}
                                    UpdateLists={UpdateLists}
                                    AddProduct={addProduct}
                                    CreateListEndpoint={CreateListEndpoint} />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

AddToModal.propType = {
    Lists: PropTypes.array.isRequired,
    UpdateLists: PropTypes.func.isRequired,
    ModalIsOpen: PropTypes.bool.isRequired,
    ToggleModal: PropTypes.func.isRequired,
    AddItemEndpoint: PropTypes.string.isRequired,
    CreateListEndpoint: PropTypes.string.isRequired
};

export default AddToModal;